import { Component, OnInit, OnDestroy } from '@angular/core';
import { CategoryService } from '../../../_services/category.service';
import { Subscription } from 'rxjs';
import { ResponseStructure } from '@iq-central-front-end/share';
import Swal from 'sweetalert2';
import { GlobalService } from '../../../_services/global.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CategoryDTO } from '../../../_models/category';

@Component({
  selector: 'iq-central-front-end-manage-category',
  templateUrl: './manage-category.component.html',
  styleUrls: ['./manage-category.component.scss'],
})
export class ManageCategoryComponent implements OnInit, OnDestroy {
  sub: Subscription = new Subscription();
  categories: any[] = [];
  subCategories: any[];
  topics: any[];
  subCategoryForm: FormGroup;
  topicForm: FormGroup;

  constructor(
    private _category: CategoryService,
    private _global: GlobalService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.initAddTopic();
    this.initAddSubcategory();
  }

  initAddSubcategory() {
    this.subCategoryForm = this.fb.group({
      categoryId: ['', Validators.required],
      name: ['', Validators.required],
    });
  }

  initAddTopic() {
    this.topicForm = this.fb.group({
      categoryId: ['', Validators.required],
      name: ['', Validators.required],
      id: ['', Validators.required],
    });
  }

  add() {
    (async () => {
      const { value: text } = await Swal.fire({
        title: 'Add a category',
        input: 'text',
        inputPlaceholder: 'Enter Category Name',
        showCloseButton: true,
        confirmButtonText: 'Add',
        allowOutsideClick: false,
        inputValidator: (value: any) => {
          if (value === '') {
            return 'Oops.. Please enter a category name.';
          }
        },
      });
      if (text) {
        const payload = { name: text } as CategoryDTO;
        this.sub.add(
          this._category.createCategory(payload).subscribe({
            next: (res: ResponseStructure) => {
              this.categories.push(res.responseResult['name']);
              this._global.successHandlerWithObject(res);
            },
          })
        );
      }
    })();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
